import { get } from './http';

// Types sourced from https://github.com/ev-proddev/campaign
// Paths below are relative to that repo root (campaign-dto/src/main/java/com/experticity/campaign/targeted/content/).

// ── Types ─────────────────────────────────────────────────────────────────────

/** @source AccessLevel.java */
export enum AccessLevel {
  Unknown = 'UNKNOWN',
  Untargeted = 'UNTARGETED',
  Targeted = 'TARGETED',
  Rewarded = 'REWARDED',
}

/** @source OrganizationAccessDto.java */
export type OrganizationAccess = {
  orgId: number;
  accessLevel: AccessLevel;
  learn: boolean;
  orgClientStatus: string;
  shop: boolean;
  targeted: boolean;
};

// ── API ───────────────────────────────────────────────────────────────────────

export function getUserBrands(): Promise<OrganizationAccess[]> {
  return get<OrganizationAccess[]>('/xapi/campaign/ext/v1/targetedContent/access');
}
